import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, useLocation } from 'react-router';
import { isWindowAvailable } from '../../../lib/utils';

export default function Login({ consumerHost, identityHost }) {
  const { pathname, search } = useLocation();
  const url = `//${identityHost}/login?return_url=//${consumerHost}${pathname}${search}`;
  const urlParts = url.split('?');

  // If this is client-side, send the user there to avoid errors with Redirect
  if (isWindowAvailable()) {
    window.location.replace(url);
    return null;
  }

  return (
    <Redirect
      to={{
        pathname: urlParts[0],
        search: `?${urlParts[1]}`,
        state: { from: window.location },
      }}
    />
  );
}

Login.propTypes = {
  consumerHost: PropTypes.string,
  identityHost: PropTypes.string,
};

Login.defaultProps = {
  consumerHost: 'www.gasbuddy.com',
  identityHost: 'iam.gasbuddy.com',
};
